import { effectiveBookingDate, } from '@debbie/common/dist/economy/case-vouchers/index.js';
import React from 'react';
import * as filters from '../../power-table/Filters.js';
import Timestamp from '../../Timestamp.js';
export const bookingDateValue = (_bookingDate, voucher) => React.createElement(Timestamp, { date: effectiveBookingDate(voucher) });
export const BookingDateFilter = (props) => (React.createElement(filters.DateRangeFilter, { from: props.filter.fromBookingDate ?? null, to: props.filter.toBookingDate ?? null, onChange: (fromBookingDate, toBookingDate) => {
        props.setFilter({
            ...props.filter,
            fromBookingDate: fromBookingDate ?? undefined,
            toBookingDate: toBookingDate ?? undefined,
        });
    } }));
//# sourceMappingURL=BookingDate.js.map